var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { mediumTextStyle } from '@socgress/ui/medium-text';
import { color } from '@socgress/ui/themes';
import { MainText } from '@socgress/ui/main-text';
export var LinkText = styled(MainText).attrs(function (props) { return ({
    as: props.as || 'a'
}); }).withConfig({ displayName: "LinkText", componentId: "sc-109zbpb" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  color: ", ";\n  \n  &[disabled] {\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  color: ", ";\n  \n  &[disabled] {\n    color: ", ";\n  }\n"])), color('textBrand'), color('surfaceDisabled'));
export var RouterLinkText = styled(Link).withConfig({ displayName: "RouterLinkText", componentId: "sc-1wbselg" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), mediumTextStyle, color('textBrand'));
var templateObject_1, templateObject_2;
